/* unplugin-vue-components disabled */import { render } from "./LoginLogComponent.vue?vue&type=template&id=5519aaee"
import script from "./LoginLogComponent.vue?vue&type=script&lang=js"
export * from "./LoginLogComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__